import React, { useCallback, useRef } from "react";
import ReactCanvasConfetti from "react-canvas-confetti";
import { useEffect } from "react";

const canvasStyles = {
  position: "fixed",
  pointerEvents: "none",
  width: "100%",
  height: "100%",
  top: 0,
  left: 0,
  zIndex: 101,
};

const Confetti = ({ isStart }) => {
  const refAnimationInstance = useRef(null);

  const getInstance = useCallback((instance) => {
    refAnimationInstance.current = instance;
  }, []);

  const makeShot = useCallback((particleRatio, opts) => {
    refAnimationInstance.current &&
      refAnimationInstance.current({
        ...opts,
        gravity: 1.3,
        origin: { y: 0.28 },
        particleCount: Math.floor(100 * particleRatio),
      });
  }, []);

  const fire = useCallback(() => {
    makeShot(0.25, {
      spread: 26,
      startVelocity: 55,
      scalar: 1.2,
      gravity: 1,
    });

    makeShot(0.2, {
      spread: 160,
      scalar: 1.2,
    });

    makeShot(0.35, {
      spread: 230,
      decay: 0.91,
      scalar: 2.8,
    });

    makeShot(0.1, {
      spread: 190,
      startVelocity: 25,
      decay: 0.92,
      scalar: 2.2,
    });

    makeShot(0.1, {
      spread: 120,
      startVelocity: 45,
      scalar: 1.2,
    });
  }, [makeShot]);

  useEffect(() => {
    if (isStart === true) {
      fire();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isStart]);

  return isStart === true ? (
    <ReactCanvasConfetti refConfetti={getInstance} style={canvasStyles} />
  ) : null;
};

export default Confetti;
